import { CSSProperties, useState } from "react";
import styles from "./MainContentItem.module.css";
import { Field, MainDataStyle } from "./Common";
import { DataTemplate } from "../map/sidesheet/addplace/AddSinglePlaceInput";
import { MainDataType } from "../createmap/CreateMap";

interface MainContentsProps {
    data: Field;
    isCreate?: boolean;
    pageType?: string | undefined;
}

const MapContentItem = ({ data, isCreate, pageType }: MainContentsProps) => {
    const template = data.template ?? DataTemplate.none;
    // style 적용 | 250828 | smyun
    // 지도만들기 중 설정한 userStyle 혹은 DB에서 가져온 userStyle 값
    const userStyle = data.style! as string | MainDataStyle | undefined;
    const isValidStyle = typeof userStyle === "object" && userStyle !== null;

    // DB에서 가져온 JSON parsing
    let parsedStyle: MainDataStyle | undefined = undefined;
    try {
        if (typeof userStyle === "string" && userStyle.trim().startsWith("{")) {
            parsedStyle = JSON.parse(userStyle);
        }
    } catch (e) {
        console.warn("❗ userStyle 파싱 실패", userStyle, e);
    }

    const value = data.value;
    const fieldName = data.fieldName;

    const [imgError, setImgError] = useState(false);

    switch (data.template ?? "") {
        case DataTemplate.imagesmode:
            return <div></div>;
        case DataTemplate.link:
            return pageType === "map" ? (
                <tbody>
                    <tr className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                        <th>{fieldName}</th>
                        <td>
                            <a href={value} target="_blank" rel="noopener noreferrer">
                                {value}
                            </a>
                        </td>
                    </tr>
                </tbody>
            ) : (
                <div className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                    <span>
                        <a className={styles[template]} href={data.value} target="_blank" rel="noopener noreferrer">
                            {data.value}
                        </a>
                    </span>
                </div>
            );

        case DataTemplate.call:
            return pageType === "map" ? (
                <tbody>
                    <tr className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                        <th>{fieldName}</th>
                        <td>
                            <a className={styles[template]} href={`tel:${value}`}>
                                {value}
                            </a>
                        </td>
                    </tr>
                </tbody>
            ) : (
                <div className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                    {/* <span>{fieldName} : </span> */}
                    <span>
                        <a className={styles[template]} href={`tel:${data.value}`}>
                            {data.value}
                        </a>
                    </span>
                </div>
            );
        case DataTemplate.attach_money:
            const transNumberV = Number(data.value);
            const numberTemplate = isNaN(transNumberV) ? data.value : Intl.NumberFormat().format(transNumberV);

            return pageType === "map" ? (
                <tbody>
                    <tr className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                        <th>{fieldName}</th>
                        <td colSpan={2}>{numberTemplate}</td>
                    </tr>
                </tbody>
            ) : (
                <div className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                    {/* <span>{fieldName} : </span> */}
                    <span>{numberTemplate}</span>
                </div>
            );

        case DataTemplate.format_quote:
            return pageType === "map" ? (
                <tbody>
                    <tr className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                        <th>{fieldName}</th>
                        <td colSpan={2}>"{data.value}"</td>
                    </tr>
                </tbody>
            ) : (
                <div className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                    {/* <span>{fieldName} : </span> */}
                    <span>"{data.value}"</span>
                </div>
            );
        default:
            return pageType === "map" ? (
                <tbody>
                    <tr className={`${styles.list} ${isCreate && styles.isCreateList}`}>
                        <th>{fieldName}</th>
                        {/* 지도 - 장소정보에 스타일 반영 | 250827 | smyun */}
                        <td
                            {...(parsedStyle && {
                                style: {
                                    color: parsedStyle.color,
                                    fontStyle: parsedStyle.fontStyle,
                                    fontWeight: parsedStyle.fontWeight,
                                    textDecoration: parsedStyle.textDecoration,
                                    textAlign: parsedStyle.textAlign,
                                } as CSSProperties,
                            })}
                        >
                            {value}
                        </td>
                    </tr>
                </tbody>
            ) : (
                // 지도만들기- 장소정보설정에 스타일 반영 | smyun
                <div
                    className={`${styles.list} ${isCreate && styles.isCreateList}`}
                    {...(isValidStyle
                        ? {
                              style: {
                                  textAlign: userStyle.textAlign,
                                  textDecoration: userStyle.textDecoration,
                                  fontStyle: userStyle.fontStyle,
                                  fontWeight: userStyle.fontWeight,
                              } as CSSProperties,
                          }
                        : {})}
                >
                    {/* <span>{fieldName} : </span> */}
                    <span style={{ color: isValidStyle ? userStyle.color : undefined }}>{data.value}</span>
                </div>
            );
    }
};

export default MapContentItem;
